import { render, staticRenderFns } from "./ProductBasedStatementComponent.vue?vue&type=template&id=12f9a19b&scoped=true"
import script from "./ProductBasedStatementComponent.vue?vue&type=script&lang=js"
export * from "./ProductBasedStatementComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12f9a19b",
  null
  
)

export default component.exports